import React, { useEffect } from 'react';
import { useState } from 'react';
import smallLogo from 'assets/images/black-logo.png';
import { Badge, Divider, Dropdown } from 'antd';
import { UserOutlined, ShoppingOutlined } from '@ant-design/icons';

import { useNavigate } from 'react-router-dom';
import {
  Curtains,
  Plantations,
  RollerShutters,
  headerAwnings,
  headerBlinds,
  headerCurtains,
  headerListAwnings,
  headerListBlinds,
  headerPS,
  headerRS,
} from './ProductCollection';
import ProductCard from './ProductCard';
import { useAuthModalStore, useNewOrderStore } from 'modules/zustand/store';
import { useAuth } from 'hooks';
import { getCurrUserDetailByUserId, User } from 'services/UserServices';
import { AxiosError } from 'axios';

const ShopFrontHeaderSticky = () => {
  const [isHoveredAwning, setIsHoveredAwning] = useState(false);
  const [isHoveredBlinds, setIsHoveredBlinds] = useState(false);
  const [isHoveredCurtains, setIsHoveredCurtains] = useState(false);
  const [isHoveredPS, setIsHoveredPS] = useState(false);
  const [isHoveredRS, setIsHoveredRS] = useState(false);
  const [isGeneral, setIsGeneral] = useState(false);
  const navigate = useNavigate();

  const closeAllDropDown = () => {
    setIsHoveredAwning(false);
    setIsHoveredBlinds(false);
    setIsHoveredCurtains(false);
    setIsHoveredPS(false);
    setIsHoveredRS(false);
    setIsGeneral(false);
  };

  const totalPrice = useNewOrderStore((state) => state.totalPrice);
  const setOnLoginModal = useAuthModalStore((state) => state.setOnLoginModal);

  const { logout } = useAuth();
  const [currUser, setCurrUser] = useState<User>();

  const fetchCurrUser = async () => {
    try {
      const data = await getCurrUserDetailByUserId();
      setCurrUser(data);
    } catch (err: any) {
      const error = err as AxiosError;
      console.log(error);
      console.log(currUser);
    }
  };
  useEffect(() => {
    fetchCurrUser();
  }, []);

  const get_menu_horizontal = () => {
    if (Number(currUser?.role_id) != 1 && Number(currUser?.role_id) != 2) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className="absolute group h-fit w-full  flex flex-col items-center justify-center  top-0 z-40 hidden lg:block px-3 py-3 bg-white text-black transition-all duration-300  hedvig-letters-sans-regular hover:shadow-xl"
      onMouseLeave={() => {
        closeAllDropDown();
      }}
    >
      <div className="w-full flex items-center justify-between my-auto mx-auto">
        <div
          className="flex flex-row items-center justify-start flex-1"
          onClick={() => {
            navigate('/');
            closeAllDropDown();
          }}
          onMouseEnter={() => {
            closeAllDropDown();
          }}
        >
          <img
            className="my-auto transition-all duration-300"
            style={{ maxHeight: '50px' }}
            src={smallLogo}
          />
        </div>
        <div
          className={` flex flex-row justify-between w-fit mx-10 text-xl gap-5 text-center `}
        >
          <span
            className="hover:underline hover:-translate-y-1 duration-300 transition-transform group awning peer"
            onMouseEnter={() => {
              closeAllDropDown();
              setIsHoveredAwning(true);
            }}
          >
            Awnings
          </span>
          <span
            className="hover:underline hover:-translate-y-1 duration-300 transition-transform"
            onMouseEnter={() => {
              closeAllDropDown();
              setIsHoveredBlinds(true);
            }}
          >
            Blinds
          </span>
          <span
            className="hover:underline hover:-translate-y-1 duration-300 transition-transform"
            onMouseEnter={() => {
              closeAllDropDown();
              setIsHoveredCurtains(true);
            }}
          >
            Curtains
          </span>
          <span
            className="hover:underline hover:-translate-y-1 duration-300 transition-transform "
            onMouseEnter={() => {
              closeAllDropDown();
              setIsHoveredPS(true);
            }}
          >
            Plantation Shutters
          </span>

          <span
            className="   hover:underline hover:-translate-y-1 duration-300 transition-transform "
            onMouseEnter={() => {
              closeAllDropDown();
              setIsHoveredRS(true);
            }}
          >
            Roller Shutters
          </span>
        </div>

        <div
          className="flex m-1 flex-row-reverse items-center gap-3 flex-1 text-xl"
          style={{ height: '40px' }}
          onMouseEnter={() => {
            closeAllDropDown();
          }}
        >
          <div
            className="flex justify-center items-center rounded-md hover:-translate-y-1 duration-300 transition-transform hover:bg-neutral-300 "
            style={{ width: '40px', height: '40px' }}
            onMouseEnter={() => {
              closeAllDropDown();
              setIsGeneral(true);
            }}
          >
            <UserOutlined style={{ fontSize: '20px' }}></UserOutlined>
          </div>
          <div
            className="flex justify-center items-center rounded-md hover:-translate-y-1 duration-300 transition-transform hover:bg-neutral-300 "
            style={{ width: '40px', height: '40px' }}
            onClick={() => {
              navigate('/order/create');
              closeAllDropDown();
            }}
          >
            <Badge dot={Number(totalPrice) != 0}>
              <ShoppingOutlined style={{ fontSize: '20px' }}></ShoppingOutlined>
            </Badge>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isHoveredAwning ? 'h-[22rem] duration-500' : 'h-[0rem] duration-0'
        }`}
      >
        <div className="max-w-screen-lg m-auto flex flex-row pt-10 justify-center">
          <div className="flex flex-col gap-3 ">
            <span className="text-lg text-neutral-500">Our Ranges</span>
            <div className="flex flex-col gap-3 ">
              {headerListAwnings.map((item, index) => {
                return (
                  <span
                    key={index}
                    className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
                    onClick={() => {
                      navigate(item.page);
                      closeAllDropDown();
                    }}
                  >
                    {item.name}
                  </span>
                );
              })}
              <span
                onClick={() => {
                  navigate('/products/awnings');
                  closeAllDropDown();
                }}
                className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
              >
                See More →
              </span>
            </div>
          </div>
          <div className="h-[22rem] px-5">
            <Divider type="vertical" className="h-full"></Divider>
          </div>
          <div className="flex flex-col gap-3 w-1/2 text-lg">
            <span className="text-lg text-neutral-500">Featured Products</span>
            <div className="grid grid-cols-2  gap-5 justify-center items-center">
              {headerAwnings.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isHoveredBlinds ? 'h-[22rem] duration-500' : 'h-[0rem] duration-0'
        }`}
      >
        <div className="max-w-screen-lg m-auto flex flex-row pt-10 justify-center">
          <div className="flex flex-col gap-3">
            <span className="text-lg text-neutral-500">Our Ranges</span>
            <div className="flex flex-col gap-3 ">
              {headerListBlinds.map((item, index) => {
                return (
                  <span
                    key={index}
                    className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
                    onClick={() => {
                      navigate(item.page);
                      closeAllDropDown();
                    }}
                  >
                    {item.name}
                  </span>
                );
              })}
              <span
                onClick={() => {
                  navigate('/products/blinds');
                  closeAllDropDown();
                }}
                className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
              >
                See More →
              </span>
            </div>
          </div>
          <div className="h-[22rem] px-5">
            <Divider type="vertical" className="h-full"></Divider>
          </div>
          <div className="flex flex-col gap-3 w-1/2 text-lg">
            <span className="text-lg text-neutral-500">Featured Products</span>
            <div className="grid grid-cols-2  gap-5 justify-center items-center">
              {headerBlinds.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isHoveredCurtains ? 'h-[22rem] duration-500' : 'h-[0rem] duration-0'
        }`}
      >
        <div className="max-w-screen-lg m-auto flex flex-row pt-10 justify-center">
          <div className="flex flex-col gap-3">
            <span className="text-lg text-neutral-500">Our Ranges</span>
            <div className="flex flex-col gap-3 ">
              {Curtains.map((item, index) => {
                return (
                  <span
                    key={index}
                    className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
                    onClick={() => {
                      navigate(item.page);
                      closeAllDropDown();
                    }}
                  >
                    {item.name}
                  </span>
                );
              })}
              <span
                onClick={() => {
                  navigate('/products/curtains');
                  closeAllDropDown();
                }}
                className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
              >
                See More →
              </span>
            </div>
          </div>
          <div className="h-[22rem] px-5">
            <Divider type="vertical" className="h-full"></Divider>
          </div>
          <div className="flex flex-col gap-3 w-1/2 text-lg">
            <span className="text-lg text-neutral-500">Featured Products</span>
            <div className="grid grid-cols-2  gap-5 justify-center items-center">
              {headerCurtains.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isHoveredPS ? 'h-[22rem] duration-500' : 'h-[0rem] duration-0'
        }`}
      >
        <div className="max-w-screen-lg m-auto flex flex-row pt-10 justify-center">
          <div className="flex flex-col gap-3">
            <span className="text-lg text-neutral-500">Our Ranges</span>
            <div className="flex flex-col gap-3 ">
              {Plantations.map((item, index) => {
                return (
                  <span
                    key={index}
                    className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
                    onClick={() => {
                      navigate(item.page);
                      closeAllDropDown();
                    }}
                  >
                    {item.name}
                  </span>
                );
              })}
              <span
                onClick={() => {
                  navigate('/products/plantations');
                  closeAllDropDown();
                }}
                className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
              >
                See More →
              </span>
            </div>
          </div>
          <div className="h-[22rem] px-5">
            <Divider type="vertical" className="h-full"></Divider>
          </div>
          <div className="flex flex-col gap-3 w-1/2 text-lg">
            <span className="text-lg text-neutral-500">Featured Products</span>
            <div className="grid grid-cols-2  gap-5 justify-center items-center">
              {headerPS.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isHoveredRS ? 'h-[22rem] duration-500' : 'h-[0rem] duration-0'
        }`}
      >
        <div className="max-w-screen-lg m-auto flex flex-row pt-10 justify-center">
          <div className="flex flex-col gap-3">
            <span className="text-lg text-neutral-500">Our Ranges</span>
            <div className="flex flex-col gap-3 ">
              {RollerShutters.map((item, index) => {
                return (
                  <span
                    key={index}
                    className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform"
                    onClick={() => {
                      navigate(item.page);
                      closeAllDropDown();
                    }}
                  >
                    {item.name}
                  </span>
                );
              })}
              <span className="text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform">
                See More →
              </span>
            </div>
          </div>
          <div className="h-[22rem] px-5">
            <Divider type="vertical" className="h-full"></Divider>
          </div>
          <div className="flex flex-col gap-3 w-1/2 text-lg">
            <span className="text-lg text-neutral-500">Featured Products</span>
            <div className="grid grid-cols-2  gap-5 justify-center items-center">
              {headerRS.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    item={item}
                    index={index}
                    aspect="aspect-video"
                  ></ProductCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`w-full transition-height overflow-hidden ${
          isGeneral
            ? `${
                currUser == undefined
                  ? 'h-[5rem]'
                  : `${get_menu_horizontal() ? 'h-[8rem]' : 'h-[17rem]'}`
              } duration-500`
            : 'h-[0rem] duration-0'
        }`}
      >
        <div className=" ml-auto flex flex-col justify-center  text-right text-3xl px-3 gap-5 h-full">
          <div
            className={`ml-auto !w-fit text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform' ${
              currUser == undefined ? 'hidden' : ''
            }`}
            onClick={() => {
              navigate(`/order`);
            }}
          >
            <span>Order List</span>
          </div>

          <div
            className={`text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform'  ${
              get_menu_horizontal() ? 'hidden' : ''
            }`}
            onClick={() => {
              navigate('/user');
            }}
          >
            <span>User Management</span>
          </div>
          <div
            className={`text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform'  ${
              get_menu_horizontal() ? 'hidden' : ''
            }`}
            onClick={() => {
              navigate('/price_management');
            }}
          >
            <span>Price Management</span>
          </div>
          <div
            className={`text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform'  ${
              currUser == undefined ? 'hidden' : ''
            }`}
            onClick={() => {
              navigate(`/user/${currUser?.user_id}`);
            }}
          >
            <span>My Details</span>
          </div>
          <div
            className={`text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform'  ${
              currUser == undefined ? 'hidden' : ''
            }`}
            onClick={() => {
              logout();
              window.location.reload();
            }}
          >
            <span>Log Out</span>
          </div>
          <div
            className={`text-xl hover:underline hover:-translate-y-1 duration-300 transition-transform'  ${
              currUser == undefined ? '' : 'hidden'
            }`}
            onClick={() => {
              setOnLoginModal();
            }}
          >
            <span>Log in</span>
          </div>
        </div>
      </div>
    </div>
  );
};

ShopFrontHeaderSticky.displayName = 'ShopFrontHeaderSticky';
export default ShopFrontHeaderSticky;
